import React from 'react';
import clsx from 'clsx';
import { Tooltip, Icon, Icons, styled } from '@nextiva/next-ui-components';
import styles from './optionRenderer.scss';

const StyledIcon = styled(Icon)`
  color: #bbb;
`;

const optionRenderer = ({ label, tooltip }) => {
  if (!tooltip) return <div className="Select-option-label">{label}</div>;

  return (
    <div className={clsx('Select-option-label', styles.option)}>
      <span className={styles.option__content}>{label}</span>
      <Tooltip title={tooltip} placement="right">
        <StyledIcon icon={Icons.info} />
      </Tooltip>
    </div>
  );
};

export default optionRenderer;
